export default __webpack_public_path__ + "static/210602_夏日活動強更預告_kr-f9e19a6ad45b2903fc9cb5c6b3257d76.png";